
import React from 'react';
import { useState, useEffect } from 'react';
import AnniversaryChecklist from './AnniversaryCheklist';
import Inputform from '../Inputform';
import HeadLine from '../HeadLine';


function AnniversaryForm() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"

    });

  }, [])

  const [input, setInput] = useState([
    {
      title: 'Anniversary Year',
      type: 'number',
      placeholder: 'Enter Anniversary Year'
    },
    {
      title: ' Enter Name',
      type: 'text',
      placeholder: 'Enter your name'
    },
    {
      title: 'Enter Email',
      type: 'email',
      placeholder: 'Enter your email'
    },
    {
      title: 'Enter Mobile Number',
      type: 'number',
      placeholder: 'Enter your Mobile Number'
    },
    {
      title: 'Enter Address',
      type: 'text',
      placeholder: 'Enter your Address'
    }

  ])
  const [data, setData] = useState([
    {
      title: 'Venue ',
      options: [
        { value: 'Banquet Halls', label: 'Banquet Halls' },
        { value: 'Lawn', label: 'Lawn' },

      ]
    },
    {
      title: 'Planing & Decor',
      options: [
        { value: 'Decoration', label: 'Decoration' }
      ]
    },
    {
      title: 'Food ',
      options: [
        { value: 'Veg Food Catering', label: 'Veg Food Catering' },
        { value: ' Non-Veg Food Catering', label: 'Non-Veg Food Catering' },
        { value: ' Veg & Non-Veg Food Catering', label: 'Veg & Non-Veg Food Catering' },
        { value: ' Health Care Menu', label: 'Health Care Menu' },
        { value: ' No Requirement', label: 'No Requirement' },
      ]
    },
    {
      title: 'Photographer',
      options: [
        { value: 'Traditional Photo & Video', label: 'Tradistiona Photo & Video' },
        { value: 'Cinematic Video', label: 'Cinematic Video' },
        { value: 'Candid Shoot', label: 'Candid Shoot' },
        { value: 'Pre Wedding Shooting', label: 'Pre Wedding Shooting' },
        { value: 'No Requirement', label: 'No Requirement' },
      ]
    },
    {
      title: 'Invitation',
      options: [
        { value: ' Invitations (cards)', label: ' Invitation (cards)' },

      ]
    },

    {
      title: 'Music',
      options: [
        { value: 'DJ', label: 'DJ' },
        { value: 'Entertainment', label: 'Entertainment' },
        { value: 'Singer', label: 'Singer' }
      ]
    },
  ])


  return (
    <div className='container' >
      <div className='row mt-5 p-3' style={{ backgroundColor: '#C6E7FD', borderRadius: '10px' }}>
        <h2 className='text-center mt-3' style={{ fontFamily: 'Dancing Script', fontWeight: 'bold' }}>Fill for best quotation</h2>
        <h3 className='text-center' style={{ fontFamily: 'Dancing Script', fontWeight: 'bold' }}>Let's celebrate one more year of hapiness</h3>
        <HeadLine />
        {
          data.map((val) => {
            return (

              <AnniversaryChecklist title={val.title} options={val.options} />
            )
          })
        }
        {
          input.map((cur) => {
            return (

              <Inputform title={cur.title} type={cur.type} placeholder={cur.placeholder} />
            )
          })
        }
        <center><input type='submit' value='SUBMIT' className='submit_btn' /></center>
      </div>


    </div>
  );
}
export default AnniversaryForm